import React from 'react';
import { ReactComponent as Warning } from '@/assets/images/svg/warning.svg';

export const ReverseContent: React.FC = (): JSX.Element => (
  <React.Fragment>
    <div className="exclude-container">
      <Warning color="#E64F49" />
      <div className="header-title-text modal__title">
        <h5 className="modal__confirmation-title">
          Você tem certeza que quer extornar esse pedido?
        </h5>
      </div>
      <div className="modal__confirmation-text">
        Ao extornar o pedido, os ingressos ficarão inválidos sem a possibilidade de recuperá-los.
      </div>
    </div>
  </React.Fragment>
);
